<template>
  <div class="app-additional-income">

    <p class="title">{{ title }}</p>

    <StepContent
      class="wrapper"
      width="lg"
    >
      <AppInput
        label="Monthly Income"
        pattern="\d*"
        type="tel"
        :value="amount"
        @input="$emit('amount-input', $event)"
        :error="amountError"
        v-data-layer
        icon
        :data-layer="`additional_income_field_${dataLayerIndex}`"
      >
        <span slot="icon">$</span>
      </AppInput>

      <AppInput
        label="Description"
        :value="description"
        @input="$emit('description-input', $event)"
        :error="descriptionError"
        v-data-layer
        :data-layer="`additional_income_description_${dataLayerIndex}`"
      />
    </StepContent>

  </div>
</template>

<script>
import StepContent from '@/components/common/step/StepContent'
import AppInput from '../inputs/AppInput'

export default {
  // Name
  name: 'additional-income-input',

  // Components
  components: {
    StepContent,
    AppInput
  },

  // Props
  props: {
    title: {
      type: String,
      required: true
    },
    amount: {
      type: String,
      required: true
    },
    amountError: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      required: true
    },
    descriptionError: {
      type: String,
      default: ''
    },
    dataLayerIndex: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  font-size: 14px;
  line-height: 1.5;
  color: $theme-text-black;
  text-align: center;

  @include breakpoint('tablet-portrait-up') {
    font-size: 25px;
  }
}

.wrapper {
  min-height: inherit;
  margin-bottom: 30px;
}
</style>
